import { render, staticRenderFns } from "./EditGatewayConfigurationPresetPanelControl.global.vue?vue&type=template&id=33501336&lang=pug&"
import script from "./EditGatewayConfigurationPresetPanelControl.global.vue?vue&type=script&lang=ts&"
export * from "./EditGatewayConfigurationPresetPanelControl.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports